import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { QueryDispatcher } from "../../shared/domain/QueryDispatcher";
import { GetOSArchitectureQuery } from "./GetOSArchitecture";

export class ChangeWindowsArchitectureSettingsCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend
  ) { }

  async run(value): Promise<any> {
    let args = {
      value:value
    }
    try {
      this.frontend.loading_def_set_windows_64 = true
      await this.dispatcher.dispatch('change.windows.arch.settings', args)
      await new GetOSArchitectureQuery(this.q_dispatcher, this.frontend).run()
    } catch (error) {
      console.log('Error while create run command', error)
    }
    this.frontend.loading_def_set_windows_64 = false
  }
}